/* eslint react/jsx-props-no-spreading: 0 */ // --> OFF

import React from "react";
import { useField, useFormikContext } from "formik";
import InputTextPR from "../../PrimeReact/InputTextPR";

export default function InputText(props) {
  const [field, meta] = useField(props);
  const { handleBlur, setFieldValue } = useFormikContext();

  const handleBlurWithTrim = (e) => {
    if (field.value) {
      setFieldValue(field.name, field.value.trim());
    }
    handleBlur(e);
  };

  return (
    <>
      <InputTextPR field={field} handleBlur={handleBlurWithTrim} {...props} />
      {meta.touched && meta.error ? (
        <div>
          <small className="p-invalid">{meta.error}</small>
        </div>
      ) : null}
    </>
  );
}
